var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "include-waiting", attrs: { id: "woerner-component" } },
    [
      _vm.waiting == true
        ? _c("div", { staticClass: "waiting" }, [
            _c("i", { staticClass: "fa fa-rotate-right fa-spin" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "widget-fw bg-grey py-5 mt-4" }, [
        _c(
          "div",
          { staticClass: "container-max" },
          [
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "div",
                { staticClass: "row savecartrow mb-5 mb-lg-2" },
                [
                  _c("div", { staticClass: "col-12 col-lg-2" }, [
                    _c(
                      "div",
                      { staticClass: "bg-white-shadow mb-2" },
                      [
                        item.variation.documents[0].data.images.variation
                          .length > 0
                          ? [
                              _c("img", {
                                staticClass: "img-fluid",
                                attrs: {
                                  src:
                                    item.variation.documents[0].data.images
                                      .variation[0].urlPreview
                                }
                              })
                            ]
                          : [
                              _c("img", {
                                staticClass: "img-fluid",
                                attrs: {
                                  src:
                                    item.variation.documents[0].data.images
                                      .all[0].urlPreview
                                }
                              })
                            ]
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-lg-10" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-6" }, [
                        _c("a", {
                          staticClass: "font-weight-bold",
                          attrs: {
                            href:
                              "/" +
                              item.variation.documents[0].data.texts.urlPath +
                              "_" +
                              item.variation.documents[0].data.item.id +
                              "_" +
                              item.variation.documents[0].data.variation.id
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              item.variation.documents[0].data.texts.name1
                            )
                          }
                        }),
                        _vm._v(" "),
                        item.variation.documents[0].data.attributes.length > 0
                          ? _c(
                              "ul",
                              { staticClass: "list-unstyled list-inline" },
                              _vm._l(
                                item.variation.documents[0].data.attributes,
                                function(attribut) {
                                  return _c("li", [
                                    _c("span", {
                                      staticClass: "font-weight-bold",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          attribut.attribute.names.name
                                        )
                                      }
                                    }),
                                    _vm._v(": "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          attribut.value.names.name
                                        )
                                      }
                                    })
                                  ])
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "text-muted small",
                          domProps: {
                            innerHTML: _vm._s(
                              item.variation.documents[0].data.variation
                                .availability.names.name
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "m-t-1",
                          domProps: {
                            innerHTML: _vm._s(
                              item.variation.documents[0].data.prices.default
                                .price.formatted
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c("div", { staticClass: "qty-box" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.number",
                                    value: item.quantity,
                                    expression: "item.quantity",
                                    modifiers: { number: true }
                                  }
                                ],
                                staticClass: "text-center",
                                attrs: { type: "text" },
                                domProps: { value: item.quantity },
                                on: {
                                  change: function($event) {
                                    return _vm.miniQuantity(
                                      item.quantity,
                                      item.minimumOrderQuantity,
                                      index
                                    )
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      item,
                                      "quantity",
                                      _vm._n($event.target.value)
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary d-inline-block",
                                on: {
                                  click: function($event) {
                                    return _vm.savedCartItemToBasket(item)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-shopping-cart" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-secondary d-inline-block color-select-second m-l-1",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteFromList(_vm.items, index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-close" })]
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _c(
                "div",
                { staticClass: "col-md-6 col-lg-2 offset-lg-8 text-left" },
                [
                  _vm.setitems.length === _vm.countsetitems
                    ? [
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-block",
                              on: {
                                click: function($event) {
                                  return _vm.buySet()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Woerner::Template.singleSetToBasket"
                                    )
                                  ) +
                                  "\n\n                                "
                              ),
                              _c("i", {
                                directives: [
                                  {
                                    name: "waiting-animation",
                                    rawName: "v-waiting-animation",
                                    value: _vm.waiting,
                                    expression: "waiting"
                                  }
                                ],
                                staticClass: "fa fa-shopping-cart",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          )
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-md-6 col-lg-2  text-left",
                  class: {
                    "offset-lg-10": _vm.setitems.length !== _vm.countsetitems
                  }
                },
                [
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-block",
                        on: {
                          click: function($event) {
                            return _vm.listToBasket()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemAddToBasket"
                              )
                            ) +
                            "\n                            "
                        ),
                        _c("i", {
                          directives: [
                            {
                              name: "waiting-animation",
                              rawName: "v-waiting-animation",
                              value: _vm.waiting,
                              expression: "waiting"
                            }
                          ],
                          staticClass: "fa fa-shopping-cart",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  ])
                ]
              )
            ])
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }